import firedux from '../firedux'

import {
  CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT
} from '../../config/constants'

export default (uid, containerId, messageCount) => {
  const ref = firedux.ref.child(CONVERSATION_REF_MESSAGE_COUNTS_ENDPOINT).child(uid).child(containerId)

  return ref.set(messageCount)
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/set_conversation_ref_read_message_count.js
 **/